import { SensorTypesGetRequestParams } from "@lib/core";

export interface SensorTypeDefaultParams extends SensorTypesGetRequestParams { }
export class SensorTypeDefaultParams {
  constructor() {
    this.select = "*";
    this.order = "id.asc";
  }
}